import { useEffect } from "react";
import Icon from "../../components/atoms/Icon";
import { LoginUseContext } from "../../context/AdminDashboard/LoginContext";
import InputGroup from "../../components/atoms/InputGroup";
import BtnModal from "../../components/atoms/BtnModal";
import toast, { Toaster } from "react-hot-toast";
import Loading from "../../components/atoms/Loading";

function LoginPage() {
  // Destructuring values from LoginUseContext hook
  const {
    handleSubmit,
    password,
    handlePasswordChange,
    loading,
    code,
    handleCodeChange,
  } = LoginUseContext();
  // Set the document title on component mount
  useEffect(() => {
    document.title = "ویاک";
  }, []);

  return (
    <div className="flex flex-row w-full h-100">
      {/* Left section with logo and information */}
      <div
        className="h-full w-1/4 bg-main-blue-300 bg-login-pattern bg-no-repeat flex flex-col justify-between py-12.5 px-10"
        dir="rtl">
        <Icon iconName={"Logo"} />
        <div>
          <div className="flex flex-col gap-3.6 text-white mb-16.5">
            <h1 className="text-18 font-semibold">
              داشبورد مدیریتی کارکنان ویاک
            </h1>
            <p className="text-14 font-normal leading-7 text-justify">
              این صفحه اینترنتی به آدرس “admin.viaq.ir” برای استفاده عموم در
              دسترس قرار نگرفته و صرفا برای ورود کارکنان ویاک ساخته شده است،
              تمام ترافیک این صفحه به صورت دائم رصد شده و هرگونه تلاش برای
              دسترسی غیر مجاز مورد پیگرد قانونی قرار می‌گیرد.
            </p>
          </div>
          <div className="flex flex-row gap-6 text-white text-14">
            <a href="https://viaq.ir/contact-us">تماس با ما</a>
            <a href="https://viaq.ir/">ورود به صفحه اصلی سایت</a>
          </div>
        </div>
      </div>
      {/* Right section with login form */}
      {loading ? (
        <Loading height={"h-100v"} />
      ) : (
        <div className="w-3/4 h-full  ">
          <div className="flex justify-center items-center h-full flex-col  relative ">
            <div dir="rtl" className="w-2/5">
              <h1 className="mb-5 text-2xl font-semibold">
                به بخش مدیریت خوش آمدید
              </h1>
              <p className="text-gray_L text-14 mb-8.5">
                لطفا اطلاعات خود را برای دریافت کد ورود وارد کنید.
              </p>
              {/* Login form */}
              <form
                onSubmit={handleSubmit}
                className="flex flex-col gap-5 mb-25">
                <InputGroup
                  label={"شماره تماس"}
                  onchange={handlePasswordChange}
                  value={password}
                  iconName="call"
                  placeholder={"مانند: 09215863622"}
                  AddClass={"admininput"}
                />
                <InputGroup
                  label={"رمز ورود"}
                  onchange={handleCodeChange}
                  value={code}
                  iconName="key"
                  placeholder={"مانند: 5368"}
                  AddClass={"admininput"}
                  type={"password"}
                />
                <BtnModal text={"ارسال کد ورود"} type="submit" />
              </form>
            </div>
            {/* Copyright information */}
            <a
              href="https://viaq.ir/"
              className="absolute bottom-2 text-13 text-dark-blue-200 hover:text-bluetext">
              تمامی حقوق این پلتفرم متعلق به شرکت دانش بنیان فناوران اینترنت
              اشیاء ویرا می باشد
            </a>
          </div>
        </div>
      )}
      {/* Toast notification component */}
      <Toaster />
    </div>
  );
}

export default LoginPage;
